// import "./styles.css";
import { FC, useState } from "react";
import { Grid, Tab, Tabs, Typography, Box } from "@mui/material";
import { TitleBarProps } from "../../../../shared/components/titleBar";
import TabPanel from "../../../../shared/components/tabpanel/tabpanel";
import ProfileEditView from "./profile";
import ChangePassword from "./changePassword";
import useQuery from "../../../../shared/components/hooks/useQuery";

import { FormViewContainer } from "../../../../shared/components/formViewContainer";
import {
  ImageCircledPreview,
  ProfileBorderBox,
  ProfileContainer,
  ProfileDetailsBox,
  ProfileViewContainer,
} from "../../../../shared/components/profileComponents";

const OrganizationDetails: FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const {
    loading,
    data,
    fetchData,
    error: personalError,
  } = useQuery(`/admin/administrators/profile`, null);

  const profileData = (data as any) || {};


  const viewTitleBar: TitleBarProps = {
    title: "User Profile",
    headerTitle: "Personal Details",
  };

  return (
    <ProfileBorderBox>
      <div>
        <FormViewContainer loading={loading} titleBar={viewTitleBar}>
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="start"
          >
            <Grid item md={1.5} ml={2}>
              <ImageCircledPreview>
                <img
                  src={
                    "https://cdn-icons-png.flaticon.com/512/3607/3607444.png"
                  }
                  alt="Preview"
                />
              </ImageCircledPreview>
            </Grid>
            <Grid item xs={5}>
              <ProfileDetailsBox>
                <Typography variant="h3">{profileData?.fullName}</Typography>
                <Typography variant="body2">{profileData?.phone}</Typography>
                <Typography variant="body2">{profileData?.email}</Typography>
              </ProfileDetailsBox>
            </Grid>
          </Grid>{" "}
        </FormViewContainer>
      </div>
      <Box style={{ padding: "16px", marginTop: "15px" }}>
        <Grid
          item
          container
          spacing={2}
          alignItems="stretch"
          justifyContent="space-between"
        >
          <Grid item xs={3.5}>
            <ProfileContainer>
              {!personalError && !loading && (
                <ProfileEditView
                  fetchData={fetchData}
                  profileData={profileData}
                  entityPermission={(data as any)?.entityPermissions}
                />
              )}
            </ProfileContainer>
          </Grid>
          <Grid item xs={8.5}>
            <ProfileViewContainer>
              <FormViewContainer
                tabs={
                  <Tabs
                    sx={{ marginBottom: "42px" }}
                    value={activeTab}
                    onChange={handleTabChange}
                  >
                    <Tab label="Change Password" />
                  </Tabs>
                }
              >
                <TabPanel value={activeTab} index={0}>
                  <ChangePassword />
                </TabPanel>
              </FormViewContainer>
            </ProfileViewContainer>
          </Grid>
        </Grid>
      </Box>
    </ProfileBorderBox>
  );
};

export default OrganizationDetails;
